/**
 * The name of the ProseMirror node that holds an inline formula (a `latex` attr), registered by
 * `EditableInlineMath` in `utils/tiptap/convert.ts`. Imported everywhere math nodes are detected or
 * created so the node name lives in exactly one place.
 */
export const INLINE_MATH_NODE_NAME = 'inlineMath';
